import React from 'react';
import '../css/aside.css'
import { useState, useEffect } from 'react';
import axios from 'axios';
import Card from './Card';

function Aside() {

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    axios.post('/giveNews')
      .then(response => {
        setData(response.data.resp.reverse());
        setLoading(false);
      })
      .catch(error => {
        console.error(error);
        setLoading(false);
      });
  }, []);
  const [sliderPosition, setSliderPosition] = useState(0);
  function toNext() {
    if(sliderPosition > -(270*5)) {
      setSliderPosition(sliderPosition - 270)
    } 
  }
  function toPrev() {
    if(sliderPosition < 0) {
      setSliderPosition(sliderPosition + 270)
    }
  }

  return (
    <div className="mainBlank">
      <aside>
          <h2>Últimas noticias</h2>
          <div className="sliderContainer"> 
            <div id="sliderPages" style={{left: `${sliderPosition}px`}}>
              {loading && <div><img src={require("../assets/img/ajax-loader-gif-6.gif")} alt=""/></div>}
              {!loading && data && data.map((cardItem) => (
                <Card
                  date={cardItem.date}
                  image_link={cardItem.image_link}
                  title={cardItem.title}
                  content={cardItem.content}
                />
              ))}
            </div>
          </div>
          <div className="slideButtons">
              <img className="sliderArrow" src="img/arrow_forward.svg" style={{rotate: '180deg'}}alt="" onClick={toPrev}/>
              <img className="sliderArrow" src="img/arrow_forward.svg" alt="" onClick={toNext}/>
          </div>   
          
          <br/>
          <a className="link" href="">Ver más</a>
      </aside>
    </div>
  );
};

export default Aside